"use client";

import { useCallback, useEffect, useRef } from "react";
import {
  consumeAutoResumeCookie,
  matchesAutoResumeContent,
  setAutoResumeCookie,
} from "@/utils/autoResumeCookie";

// Recovery belongs to this detail-page visit. Nothing persists after leaving
// unless the user explicitly starts the matching content during this visit.
export default function useContentAutoResume(slug) {
  const visit = useRef(null);
  const active = useRef(false);

  useEffect(() => {
    active.current = true;
    if (slug && visit.current?.slug !== slug) {
      const payload = consumeAutoResumeCookie();
      visit.current = { slug, payload: payload?.slug === slug ? payload : null };
    }
    return () => { active.current = false; };
  }, [slug]);

  return useCallback((season = null, episode = null) => {
    if (!active.current || visit.current?.slug !== slug) return;
    const payload = visit.current.payload;
    visit.current.payload = null;
    if (matchesAutoResumeContent(payload, slug, season, episode)) {
      setAutoResumeCookie(payload);
    }
  }, [slug]);
}
